const { params = {}, errors = {} } = window.FORM_DATA || {}
const {
  idNumber = null,
  birthDate = null,
  licenseType = null,
  carType = null,
  carPlateNumbers = null,
  carPlateLetters = '',
  carSerialNumber = null
} = params

const processCarPlateLetters = (carPlateLetters, carType, country) => {
  const lettersOnly = carPlateLetters.replace(/[^a-zA-Zء-ي]/g, '').replace(/ /g, '')
  const length = (country === 'sa' && carType === 'bike') ? 2 : 3
  return lettersOnly.slice(0, length).split('').join(' ')
}

export default () => ({
  idNumber,
  birthDate,
  licenseType,
  carType,
  carPlateNumbers,
  carPlateLetters,
  carSerialNumber,
  errors,

  init () {
    this.$watch('carPlateLetters', (value) => {
      const country = sessionStorage.getItem('selectedCountry') || 'sa'
      this.carPlateLetters = processCarPlateLetters(value, this.carType, country)
    })
  }
})
